import SplineAreaChartFortigatePing from "@components/charts/Fortigate_charts/SplineAreaChartFortigatePing";
import SplineAreaChartFortigateStarlinkCorporate from "@components/charts/Fortigate_charts/SplineAreaChartFortigateStarlinkCorporate";
import SplineAreaChartFortigateStarlinkWan1 from "@components/charts/Fortigate_charts/SplineAreaChartFortigateStarlinkWan1";
import SplineAreaChartFortigateStarlinkWelfare from "@components/charts/Fortigate_charts/SplineAreaChartFortigateStarlinkWelfare";
import Button from "@components/common/Button";
import CustomAccordion from "@components/common/CustomAccordion";
import DownloadIcon from "@components/icons/DownloadIcon";
import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Fortigate = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [openAccordions, setOpenAccordions] = useState({});

	const fortigatePing = useSelector((state) => state.modules.vessels.fortigate.pingHighLatency);
	const loadingFortigate = useSelector((state) => state.modules.vessels.fortigate.loading);

	const fortigateCorporate = useSelector(
		(state) => state.modules.vessels.fortigate.starlinkFortigateInterfaceCorporate,
	);

	const fortigateWelfare = useSelector(
		(state) => state.modules.vessels.fortigate.starlinkFortigateInterfaceWelfare,
	);

	const fortigateWan1 = useSelector(
		(state) => state.modules.vessels.fortigate.starlinkFortigateInterfaceWAN1,
	);

	const fortigateWan2 = useSelector(
		(state) => state.modules.vessels.fortigate.starlinkFortigateInterfaceWAN2,
	);

	const cybersecurityData = useSelector((state) => state.modules.vessels.cybersecurity.data);

	useEffect(() => {
		if (fortigatePing?.length > 0 && fortigatePing[0]?.data?.metric?.length > 0) {
			const newAccordionState = {};
			fortigatePing[0].data.metric.forEach((_, index) => {
				newAccordionState[`Ping High Latency-${index}`] = true;
			});
			setOpenAccordions(newAccordionState);
		}

		if (fortigateCorporate?.length > 0 && fortigateCorporate[0]?.data?.metric?.length > 0) {
			const newAccordionState = {};
			fortigateCorporate[0].data.metric.forEach((_, i) => {
				newAccordionState[`STARLINK Fortigate Interface Corporate-${i}`] = true;
			});
			setOpenAccordions(newAccordionState);
		}

		if (fortigateWelfare?.length > 0 && fortigateWelfare[0]?.data?.metric?.length > 0) {
			const newAccordionState = {};
			fortigateWelfare[0].data.metric.forEach((_, i) => {
				newAccordionState[`STARLINK Fortigate Interface Welfare-${i}`] = true;
			});
			setOpenAccordions(newAccordionState);
		}

		if (fortigateWan1?.length > 0 && fortigateWan1[0]?.data?.metric?.length > 0) {
			const newAccordionState = {};
			fortigateWan1[0].data.metric.forEach((_, i) => {
				newAccordionState[`STARLINK Fortigate Interface Wan1-${i}`] = true;
			});
			setOpenAccordions(newAccordionState);
		}

		if (fortigateWan2?.length > 0 && fortigateWan2[0]?.data?.metric?.length > 0) {
			const newAccordionState = {};
			fortigateWan2[0].data.metric.forEach((_, i) => {
				newAccordionState[`STARLINK Fortigate Interface Wan2-${i}`] = true;
			});
			setOpenAccordions(newAccordionState);
		}
	}, [fortigatePing, fortigateCorporate, fortigateWelfare, fortigateWan1, fortigateWan2]);

	const toggleAccordion = (id) => {
		setOpenAccordions((prev) => ({
			...prev,
			[id]: !prev[id],
		}));
	};
	const isMobile = useIsMobile();

	return (
		<>
			<div>
				{loadingFortigate ? (
					<div className="flex h-64 items-center justify-center">
						<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
					</div>
				) : (
					<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
						<div className="flex justify-start">
							{cybersecurityData && cybersecurityData[0]?.traffic_file && (
								<Button
									text="Network Usage"
									className="!p-2 !m-0 text-sm text-white"
									color="blue"
									icon={DownloadIcon}
									position="after"
									classNameIcon="w-4 h-4 ms-2 text-white"
									disabled={!cybersecurityData[0]?.traffic_file}
									onClick={() => {
										const report = cybersecurityData[0]; // Assuming the report is at index 0
										const pdfFileUrl = `${import.meta.env.VITE_API_BACKEND}${report?.traffic_file}`;
										window.open(pdfFileUrl, "_blank");
									}}
								/>
							)}
						</div>
						{/* Ping High Latency */}
						<div className="grid grid-cols-1 gap-6">
							{fortigatePing[0]?.data?.metric?.length > 0 ? (
								fortigatePing[0].data.metric.map((ping, index) => {
									const accordionKey = `Ping High Latency-${index}`;
									return (
										<div key={index} className="chart-row-100">
											<div className="chart-column w-100">
												<CustomAccordion
													title={fortigatePing[0].type}
													id={`ping-${index}`}
													isOpen={openAccordions[accordionKey] ?? true}
													toggleAccordion={() => toggleAccordion(accordionKey)}
													classCss={`${openAccordions[accordionKey] ? "border-0" : ""}`}
													isMobile={isMobile}
												>
													<SplineAreaChartFortigatePing
														data={ping.data}
														times={ping.times}
														type={fortigatePing[0].type}
														id={`${fortigatePing[0].id}`}
														dispatch={dispatch}
														navigate={navigate}
													/>
												</CustomAccordion>
											</div>
										</div>
									);
								})
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No High Latency Ping Data Available.
										</p>
									</div>
								</div>
							)}
						</div>

						{/* Fortigate Corporate */}
						<div className="grid grid-cols-1 gap-4">
							{fortigateCorporate[0]?.data?.metric?.length > 0 ? (
								fortigateCorporate[0].data.metric.map((f_corp, index) => {
									const accordionKey = `STARLINK Fortigate Interface Corporate-${index}`;
									return (
										<div key={index} className="chart-row-100">
											<div className="chart-column w-100">
												<CustomAccordion
													title={fortigateCorporate[0].type}
													id={`fortigate_corporate-${index}`}
													isOpen={openAccordions[accordionKey] ?? true}
													toggleAccordion={() => toggleAccordion(accordionKey)}
													classCss={`${openAccordions[accordionKey] ? "border-0" : ""}`}
													isMobile={isMobile}
												>
													<SplineAreaChartFortigateStarlinkCorporate
														data={f_corp.data}
														times={f_corp.times}
														type={fortigateCorporate[0].type}
														id={`${fortigateCorporate[0].id}`}
														dispatch={dispatch}
														navigate={navigate}
													/>
												</CustomAccordion>
											</div>
										</div>
									);
								})
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No STARLINK Fortigate Interface Corporate Data Available.
										</p>
									</div>
								</div>
							)}
						</div>

						{/* Fortigate Welfare */}
						<div className="grid grid-cols-1 gap-4">
							{fortigateWelfare[0]?.data?.metric?.length > 0 ? (
								fortigateWelfare[0].data.metric.map((f_welf, index) => {
									const accordionKey = `STARLINK Fortigate Interface Welfare-${index}`;
									return (
										<div key={index} className="chart-row-100">
											<div className="chart-column w-100">
												<CustomAccordion
													title={fortigateWelfare[0].type}
													id={`fortigate_corporate-${index}`}
													isOpen={openAccordions[accordionKey] ?? true}
													toggleAccordion={() => toggleAccordion(accordionKey)}
													classCss={`${openAccordions[accordionKey] ? "border-0" : ""}`}
													isMobile={isMobile}
												>
													<SplineAreaChartFortigateStarlinkWelfare
														data={f_welf.data}
														times={f_welf.times}
														type={fortigateWelfare[0].type}
														id={`${fortigateWelfare[0].id}`}
														dispatch={dispatch}
														navigate={navigate}
													/>
												</CustomAccordion>
											</div>
										</div>
									);
								})
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No STARLINK Fortigate Interface Welfare Data Available.
										</p>
									</div>
								</div>
							)}
						</div>

						{/* Fortigate Wan1 */}
						<div className="grid grid-cols-1 gap-4">
							{fortigateWan1[0]?.data?.metric?.length > 0 ? (
								fortigateWan1[0].data.metric.map((f_wan1, index) => {
									const accordionKey = `STARLINK Fortigate Interface Wan1-${index}`;
									return (
										<div key={index} className="chart-row-100">
											<div className="chart-column w-100">
												<CustomAccordion
													title={fortigateWan1[0].type}
													id={`fortigate_wan1-${index}`}
													isOpen={openAccordions[accordionKey] ?? true}
													toggleAccordion={() => toggleAccordion(accordionKey)}
													classCss={`${openAccordions[accordionKey] ? "border-0" : ""}`}
													isMobile={isMobile}
												>
													<SplineAreaChartFortigateStarlinkWan1
														data={f_wan1.data}
														times={f_wan1.times}
														type={fortigateWan1[0].type}
														id={`${fortigateWan1[0].id}`}
														dispatch={dispatch}
														navigate={navigate}
													/>
												</CustomAccordion>
											</div>
										</div>
									);
								})
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No STARLINK Fortigate Interface Wan1 Data Available.
										</p>
									</div>
								</div>
							)}
						</div>

						{/* Fortigate Wan2 */}
						{/* <div className="grid grid-cols-1 gap-4">
              {fortigateWan2[0]?.data?.metric?.length > 0 ? (
                fortigateWan2[0].data.metric.map((f_wan2, index) => {
                  const accordionKey = `STARLINK Fortigate Interface Wan2-${index}`;
                  return (
                    <div key={index} className="chart-row-100">
                      <div className="chart-column w-100">
                        <CustomAccordion
                          title={fortigateWan2[0].type}
                          id={`fortigate_wan2-${index}`}
                          isOpen={openAccordions[accordionKey] ?? true}
                          toggleAccordion={() => toggleAccordion(accordionKey)}
                          classCss={`${openAccordions[accordionKey] ? "border-0" : ""}`}
                          isMobile={isMobile}

                        >
                          <SplineAreaChartFortigateStarlinkWan2
                            data={f_wan2.data}
                            times={f_wan2.times}
                            type={fortigateWan2[0].type}
                            id={`${fortigateWan2[0].id}`}
                            dispatch={dispatch}
                            navigate={navigate}
                          />
                        </CustomAccordion>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="w-full p-4 rounded-lg shadow-lg bg-yellow-100 border-l-4 border-yellow-500 flex items-start space-x-3">
                  <div className="text-white rounded-full flex items-center justify-center">
                    <svg
                      className="w-6 h-6 text-yellow-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                    </svg>
                  </div>
                  <div className="text-yellow-900">
                    <p className="font-semibold text-yellow-800">
                      No STARLINK Fortigate Interface Wan2 Data Available.
                    </p>
                  </div>
                </div>
              )}
            </div> */}
					</div>
				)}
			</div>
		</>
	);
};
export default Fortigate;
